var exports = {
  "aL": "titleWithBack__g9HPHZ",
  "Gv": "backButton__AEji17",
  "Mu": "issueTypeRenameDialog__dW1mIS",
  "v5": "dialogBody__XCVbdy",
  "jo": "contentBox__RPW3PC",
  "sr": "formControl__RoTkyK",
  "j": "videoContainer__OvoM0n",
  "sM": "srOnly__0fESYZ",
  "Jo": "contentSection__463ldQ",
  "fQ": "videoSection__cDI4i-",
  "Ki": "video__OTzKbE",
};

module.exports = exports;
